// @ts-ignore
import { Receipt as ReceiptLib } from "./receipt";
// @ts-ignore
import { qrcode as qrcodeDefault } from "@lemmonhq/external/qrcode";

// https://github.com/receiptline/receiptjs
export type ReceiptInstace = {
  toCommand: () => Promise<string>;
  toSVG: () => Promise<string>;
  toPNG: () => Promise<string>;
};
export const Receipt: {
  from: (md: string, options: string) => ReceiptInstace;
} = ReceiptLib;
export const qrcode = qrcodeDefault;
